import {
    Box,
    Text,
} from "@chakra-ui/react";

import {
    ArrowLeft,
} from "lucide-react";

import {
    useNavigate,
} from "react-router-dom";

import PolicyMetadata from "./PolicyMetadata";

const PolicyHero = ({
    document,
}) => {
    const navigate =
        useNavigate();

    return (
        <Box>
            <Text
                display="flex"
                alignItems="center"
                gap={2}
                cursor="pointer"
                color="#2453FF"
                fontWeight="600"
                mb={6}
                w="fit-content"
                onClick={() =>
                    navigate(-1)
                }
                _hover={{
                    color:
                        "#1E46D8",
                }}
            >
                <ArrowLeft
                    size={18}
                />
                Back
            </Text>

            <Text
                fontSize={{
                    base: "2xl",
                    md: "4xl",
                }}
                fontWeight="700"
                color="#2453FF"
            >
                {
                    document.title
                }
            </Text>

            <PolicyMetadata
                updatedAt={
                    document.updatedAt
                }
                version={
                    document.version || "1.0.0"
                }
            />

            
        </Box>
    );
};

export default PolicyHero;